/**
 * Rótulos amigáveis das variáveis Handlebars usadas nos templates de e-mail.
 *
 * A chave é o nome técnico da propriedade retornada por `GET template/payload`
 * (ver Clearences.Notifications — Msg.PayloadInvoice / Msg.PartnerTransfer).
 * O valor é o texto exibido ao usuário em /configuracoes.
 *
 * Nomes ausentes daqui caem no fallback automático (PascalCase separado por
 * espaços), então esquecer de mapear uma variável nova não quebra a tela.
 */
export const TEMPLATE_VARIABLE_LABELS: Record<string, string> = {
  // Comuns
  AmountTotal: 'Valor Total',
  Amount: 'Valor',
  Channel: 'Canal',
  Chanel: 'Canal',
  Client: 'Cliente',
  ClientDocument: 'CPF/CNPJ do Cliente',
  Number: 'Número do Contrato',
  ProductName: 'Produto',
  Status: 'Status',
  Percentual: 'Percentual',
  FinancialInstitution: 'Instituição Financeira',
  ContractId: 'ID do Contrato',
  QueryNumber: 'Número da Consulta',
  ProductionDate: 'Data de Produção',
  BeneficiaryName: 'Nome do Beneficiário',
  BeneficiaryDocument: 'CPF/CNPJ do Beneficiário',
  BeneficiaryFee: 'Taxa do Beneficiário',
  BeneficiaryType: 'Tipo de Beneficiário',

  // Faturamento (Invoice)
  TotalInvoice: 'Total Faturado',
  InvoiceAmount: 'Valor Faturado',
  InvoiceUrl: 'Link da Fatura',
  NFes: 'NFes',
  NFe: 'NFe',
  SerieNFe: 'Série da NFe',
  Batchs: 'Lotes',
  Contracts: 'Contratos',
  BankId: 'ID do Banco',
  BankName: 'Nome do Banco',
  BankDocument: 'CNPJ do Banco',
  BankFantasyName: 'Nome Fantasia do Banco',
  Prazo: 'Prazo',
  BatchId: 'ID do Lote',
  BatchNumber: 'Número do Lote',
  BatchStatus: 'Status do Lote',
  NumberOfContracts: 'Qtd. de Contratos',
  Partner: 'Parceiro',
  EmissionDate: 'Data de Emissão',
  CreateDate: 'Data de Criação',

  // Repasse (Transfer)
  TotalTransfer: 'Total do Repasse',
  TransferAmount: 'Valor do Repasse',
  EmailLink: 'Link do E-mail',
  SendLimitDateForBillPartner: 'Prazo para Envio da NF',
  ReverseBalance: 'Saldo de Estorno',
  TotalReversed: 'Total Estornado',
  Reverses: 'Estornos',
  ReverseId: 'ID do Estorno',
  Balance: 'Saldo',
  EstimatedPaymentDate: 'Data Prevista de Pagamento',
  EstimadedPaymentDate: 'Data Prevista de Pagamento'
};

/** Sufixo aplicado a variáveis de escopo de lista (`{{this.X}}`). */
export const TEMPLATE_VARIABLE_ITEM_SUFFIX = ' (item)';
